// extracted by mini-css-extract-plugin
export default {"overlay":"Overlay-module--overlay--6af57","content":"Overlay-module--content--f291b","marker":"Overlay-module--marker--e1d20"};